import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ConsentService } from '@core/services/consent.service';

/**
 * Asks once whether Google Analytics may set cookies (usage stats and
 * measuring sign-ups from ads). Shown until the visitor answers; the cookie
 * policy page can ask again. Declining changes nothing in the app itself.
 */
@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [RouterLink, MatButtonModule, TranslateModule],
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss'],
})
export class CookieConsentBannerComponent {
  private readonly consent = inject(ConsentService);

  readonly show = computed(() => this.consent.choice() === null);

  accept(): void {
    this.consent.accept();
  }

  decline(): void {
    this.consent.decline();
  }
}
